export default "__VITE_ASSET__BHneGcrY__"